import { render, staticRenderFns } from "./ProfilePreferencesView.vue?vue&type=template&id=eb2702da"
import script from "./ProfilePreferencesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePreferencesView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports